import React, { useContext } from "react";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { CircularProgress } from "@mui/material";
import { useApplication } from "../../hooks/useApplication";

const ApplicationContext = React.createContext();

export function useApplicationContext() {
  return useContext(ApplicationContext);
}
export function ApplicationProvider({ applicationId, children }) {
  const { setError } = useErrorMessage();
  const { application, loading, error } = useApplication(applicationId);
  if (error) {
    setError(error);
  }

  if (loading || !application) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <ApplicationContext.Provider value={application}>
      {children}
    </ApplicationContext.Provider>
  );
}
